import { render, staticRenderFns } from "./px.vue?vue&type=template&id=20e391f2&scoped=true"
import script from "./px.vue?vue&type=script&lang=js"
export * from "./px.vue?vue&type=script&lang=js"
import style0 from "./px.vue?vue&type=style&index=0&id=20e391f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e391f2",
  null
  
)

export default component.exports